module.exports = __webpack_public_path__ + "static/img/20.782f913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/20.png
// module id = 8YLr
// module chunks = 0